import { UserSystemRoleModelPermissionMap } from '../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { SSOPage } from '../../sso/SSOPage';
import { ISettingsItem } from '../ISettingsItem';

export const SSOSettingsItem: ISettingsItem = {
  id: 'ssoPage',
  settingsItem: {
    key: 'ssoPage',
    title: 'settings.ssoPage',
    buttons: [
      {
        title: 'SSO',
        url: '/settings/sso',
        permissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
      },
    ],
    permissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    infoText: 'settings.ssoProvider',
    orderIndex: 1000,
  },
  routers: [
    {
      key: 'sso-providers-list-settings',
      path: '/settings/sso',
      pageTitle: 'SSO',
      component: SSOPage,
      allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    },
  ],
};
